{
  "ui": {
    "close": "Zamknij",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "edit": "Edytuj",
    "delete": "Usuń",
    "add": "Dodaj",
    "more": "Więcej",
    "retry": "Spróbuj ponownie",
    "showMore": "Pokaż więcej",
    "done": "Gotowe",
    "password": {
      "show": "Pokaż hasło",
      "hide": "Ukryj hasło"
    }
  },
  "preferences": {
    "language": "Język"
  },
  "app": {
    "crash": {
      "title": "Coś poszło nie tak",
      "description": "Strona nie załadowała się do końca. Odśwież ją — zwykle to pomaga.",
      "home": "Na stronę główną"
    }
  },
  "notFound": {
    "title": "Nie ma takiej strony",
    "description": "Link mógł się zdezaktualizować albo zawiera literówkę.",
    "home": "Na stronę główną"
  },
  "home": {
    "title": "Wstęp na seans — tylko z zaproszeniem",
    "description": "Otwórz link od prowadzącego — przez niego wejdziesz do sali.",
    "hostSignIn": "Prowadzę seanse — zaloguj się"
  },
  "auth": {
    "login": "Login",
    "password": "Hasło",
    "signIn": "Zaloguj się",
    "signInTitle": "Logowanie dla prowadzących",
    "signOut": "Wyloguj się",
    "displayName": "Imię widoczne dla widzów",
    "newPassword": "Ustal hasło",
    "welcome": {
      "title": "Witamy w Seans",
      "expires": "Link jest ważny do {{date}}",
      "submit": "Utwórz konto",
      "invalid": "Link z zaproszeniem nie działa",
      "invalidHint": "Został już użyty albo wygasł. Poproś właściciela o nowy."
    }
  },
  "validation": {
    "required": "Uzupełnij to pole",
    "login": "Od 3 do 32 znaków: litery łacińskie, cyfry, kropka, myślnik, podkreślnik",
    "password": "Co najmniej 10 znaków",
    "displayName": "Od 1 do 40 znaków",
    "title": "Od 1 do 120 znaków",
    "trackLabel": "Najwyżej 60 znaków"
  },
  "roles": {
    "account": {
      "owner": "Właściciel",
      "host": "Prowadzący"
    },
    "participant": {
      "host": "Prowadzący",
      "guest": "Widz"
    }
  },
  "errors": {
    "unauthenticated": "Sesja wygasła. Zaloguj się ponownie.",
    "forbidden": "Nie masz do tego uprawnień.",
    "not_found": "Nie znaleziono — możliwe, że zostało usunięte.",
    "validation_failed": "Sprawdź wprowadzone dane.",
    "rate_limited": "Za dużo prób. Odczekaj chwilę i spróbuj ponownie.",
    "credentials_invalid": "Nieprawidłowy login lub hasło.",
    "account_disabled": "Dostęp do tego konta jest wyłączony. Skontaktuj się z właścicielem.",
    "login_taken": "Ten login jest już zajęty.",
    "invitation_invalid": "Zaproszenie jest nieważne lub wygasło.",
    "invite_invalid": "Link do seansu jest nieważny. Poproś prowadzącego o nowy.",
    "screening_ended": "Seans już się zakończył.",
    "participant_banned": "Prowadzący zablokował ci dostęp do tego seansu.",
    "playback_version_conflict": "Ktoś właśnie sterował filmem — pokazujemy aktualny stan.",
    "asset_not_ready": "Film jest jeszcze przetwarzany.",
    "asset_in_use": "Film jest używany w otwartych seansach — najpierw je zakończ.",
    "track_not_deletable": "Tej ścieżki nie można usunąć.",
    "upload_too_large": "Plik jest za duży.",
    "unsupported_subtitle_format": "Potrzebny jest plik napisów SRT, VTT lub ASS.",
    "realtime_unavailable": "Połączenie wideo jest teraz niedostępne. Spróbuj za minutę.",
    "internal": "Błąd serwera. Spróbuj ponownie.",
    "network": "Brak połączenia z serwerem. Sprawdź internet.",
    "timeout": "Serwer długo nie odpowiada. Spróbuj ponownie.",
    "invalid_response": "Serwer odpowiedział w nieoczekiwany sposób. Odśwież stronę.",
    "admission_pending": "Prowadzący jeszcze nie wpuścił cię do sali.",
    "admission_denied": "Prośba o wejście została odrzucona.",
    "admission_decision_conflict": "O tej prośbie już zdecydowano — odświeżyliśmy listę.",
    "unsupported_image_format": "Potrzebny jest obraz JPEG, PNG lub WebP."
  },
  "studio": {
    "home": "Seans — studio",
    "account": "Konto: {{name}}",
    "nav": {
      "label": "Sekcje studia",
      "screenings": "Seanse",
      "library": "Filmy",
      "hosts": "Prowadzący"
    },
    "profile": {
      "menu": "Profil",
      "title": "Profil",
      "name": "Imię widoczne dla widzów",
      "nameHint": "Goście zobaczą nowe imię, gdy następnym razem wejdą do sali albo odświeżą stronę.",
      "saved": "Imię zapisane"
    }
  },
  "screenings": {
    "create": "Nowy seans",
    "created": "Seans utworzony",
    "saved": "Zmiany zapisane",
    "filter": "Które seanse pokazać",
    "filters": {
      "open": "Nadchodzące",
      "ended": "Zakończone"
    },
    "status": {
      "ended": "Zakończony"
    },
    "openRoom": "Otwórz salę",
    "copyLink": "Kopiuj link",
    "linkCopied": "Link skopiowany",
    "empty": {
      "open": "Nie ma jeszcze seansów",
      "ended": "Brak zakończonych seansów",
      "noFilms": "Najpierw dodaj film"
    },
    "policy": {
      "hosts": "Tylko prowadzący",
      "everyone": "Wszyscy uczestnicy"
    },
    "form": {
      "createTitle": "Nowy seans",
      "editTitle": "Seans",
      "create": "Utwórz",
      "film": "Film",
      "filmPlaceholder": "Wybierz film",
      "filmRequired": "Wybierz film",
      "filmChangeResets": "Film zacznie się od początku, zatrzymany",
      "title": "Tytuł",
      "titlePlaceholder": "Jak tytuł filmu",
      "startsAt": "Początek",
      "startsAtRequired": "Podaj datę i godzinę",
      "control": "Kto steruje filmem",
      "approval": "Wpuszczaj po akceptacji",
      "approvalOn": "Goście czekają, aż ich wpuścisz.",
      "approvalOff": "Każdy z linkiem wchodzi od razu.",
      "approvalOffLetsIn": "Czekający ({{count}}) wejdą od razu po zapisaniu."
    },
    "rotate": {
      "action": "Nowy link",
      "title": "Zastąpić link z zaproszeniem?",
      "consequence": "Stary link przestanie działać. Osoby, które są już w sali, zostaną w niej.",
      "confirm": "Zastąp",
      "done": "Link zastąpiony — wyślij nowy"
    },
    "end": {
      "action": "Zakończ seans",
      "title": "Zakończyć „{{title}}”?",
      "consequence": "Sala zamknie się dla wszystkich: rozmowa i film się zatrzymają, nikt nie wejdzie przez link. Tego nie da się cofnąć.",
      "confirm": "Zakończ",
      "done": "Seans zakończony"
    },
    "delete": {
      "title": "Usunąć „{{title}}”?",
      "consequence": "Seans i jego czat zostaną usunięte na zawsze, a link przestanie działać.",
      "confirm": "Usuń",
      "done": "Seans usunięty"
    }
  },
  "library": {
    "add": "Dodaj film",
    "empty": "W bibliotece nie ma jeszcze filmów",
    "title": "Tytuł",
    "resolution": "{{height}}p",
    "status": {
      "awaiting_upload": "Czeka na plik",
      "queued": "W kolejce",
      "processing": "Przetwarzanie",
      "ready": "Gotowy",
      "failed": "Błąd",
      "withPercent": "{{status}} · {{percent}}%"
    },
    "upload": {
      "start": "Prześlij",
      "started": "„{{title}}” jest przesyłany",
      "pick": "Wybierz plik wideo lub przeciągnij go tutaj",
      "pickHint": "MKV, MP4, AVI, MOV — dowolnej wielkości",
      "fileRequired": "Wybierz plik",
      "amount": "{{sent}} z {{total}}",
      "uploading": "Przesyłanie · {{percent}}%",
      "paused": "Wstrzymano",
      "failed": "Połączenie zostało przerwane",
      "pause": "Wstrzymaj",
      "resume": "Wznów",
      "cancel": "Anuluj przesyłanie",
      "cancelTitle": "Anulować przesyłanie?",
      "cancelConsequence": "Film „{{title}}” i przesłana już część pliku zostaną usunięte.",
      "cancelConfirm": "Anuluj przesyłanie",
      "continue": "Wznów",
      "continueTitle": "Wznów przesyłanie „{{title}}”",
      "pickAgain": "Wybierz ten sam plik: {{filename}}",
      "wrongFile": "To inny plik. Potrzebny jest {{filename}}"
    },
    "failure": {
      "upload_incomplete": "Plik nie został przesłany w całości.",
      "probe_failed": "Nie udało się odczytać pliku — może być uszkodzony.",
      "no_video_stream": "W pliku nie ma obrazu.",
      "transcode_failed": "Nie udało się przetworzyć wideo.",
      "subtitle_unsupported": "Ten format napisów nie jest obsługiwany.",
      "subtitle_convert_failed": "Nie udało się odczytać napisów."
    }
  },
  "asset": {
    "quality": "Jakość",
    "noRenditions": "Pojawi się po przetworzeniu",
    "duration": "Czas trwania",
    "resolution": "Rozdzielczość",
    "size": "Rozmiar pliku",
    "added": "Dodano",
    "file": "Plik źródłowy",
    "rename": "Zmień tytuł",
    "renamed": "Tytuł zapisany",
    "deleteBlocked_one": "Nie można usunąć: film jest w {{count}} seansie",
    "deleteBlocked_few": "Nie można usunąć: film jest w {{count}} seansach",
    "deleteBlocked_many": "Nie można usunąć: film jest w {{count}} seansach",
    "deleteBlocked_other": "Nie można usunąć: film jest w {{count}} seansu",
    "usedBy": "Jest w seansach: {{titles}}",
    "missing": "Nie znaleziono filmu",
    "delete": {
      "title": "Usunąć „{{title}}”?",
      "consequence": "Film, jego ścieżki i przetworzone pliki zostaną usunięte na zawsze.",
      "done": "Film usunięty"
    },
    "poster": {
      "change": "Zmień plakat",
      "dialogTitle": "Nowy plakat",
      "preview": "Podgląd plakatu",
      "pick": "Wybierz obraz lub przeciągnij go tutaj",
      "formats": "{{formats}} · do {{size}}",
      "tooLarge": "Obraz jest większy niż {{size}}.",
      "save": "Zapisz plakat",
      "saved": "Plakat zmieniony",
      "reset": "Przywróć kadr z filmu",
      "resetTitle": "Przywrócić kadr z filmu?",
      "resetConsequence": "Twój plakat zniknie, a wszędzie — w studiu, zaproszeniach i w sali — wróci kadr z samego filmu.",
      "resetConfirm": "Przywróć kadr",
      "resetDone": "Wrócił kadr z filmu",
      "source": {
        "frame": "Kadr z filmu",
        "upload": "Własny plakat"
      }
    }
  },
  "tracks": {
    "numbered": "Ścieżka {{number}}",
    "language": "Język",
    "languageUnset": "Nie podano",
    "label": "Nazwa",
    "labelOptional": "Nazwa (opcjonalnie)",
    "default": "Domyślna",
    "defaultHint": "Włącza się widzom automatycznie",
    "saved": "Ścieżka zapisana",
    "kind": {
      "audio": "Ścieżki dźwiękowe",
      "subtitle": "Napisy"
    },
    "empty": {
      "audio": "Film nie ma dźwięku",
      "subtitle": "Nie ma jeszcze napisów"
    },
    "status": {
      "processing": "Przetwarzanie",
      "ready": "Gotowe",
      "failed": "Błąd"
    },
    "delete": {
      "title": "Usunąć „{{name}}”?",
      "consequence": "Widzowie nie będą już mogli wybrać tych napisów.",
      "done": "Napisy usunięte"
    },
    "upload": {
      "title": "Dodaj napisy",
      "submit": "Prześlij",
      "pick": "Wybierz plik z napisami",
      "formats": "{{formats}} · do {{size}}, dowolne kodowanie",
      "fileRequired": "Wybierz plik",
      "tooLarge": "Plik jest większy niż {{size}}",
      "done": "Napisy przesłane — przetwarzamy"
    }
  },
  "hosts": {
    "empty": "Nie ma jeszcze prowadzących",
    "you": "to ty",
    "disabled": "Dostęp wyłączony",
    "since": "od {{date}}",
    "noAccess": "Ta sekcja jest tylko dla właściciela",
    "noAccessHint": "Prowadzących zaprasza i wyłącza właściciel studia.",
    "access": {
      "label": "Dostęp",
      "revoke": "Wyłącz",
      "revoked": "{{name}} nie może się już zalogować",
      "restored": "{{name}} znów może się zalogować",
      "revokeTitle": "Wyłączyć dostęp dla {{name}}?",
      "revokeConsequence": "{{name}} straci dostęp do studia i nie zaloguje się, dopóki nie włączysz dostępu. Seanse i filmy zostaną."
    },
    "invite": {
      "action": "Zaproś",
      "title": "Zaproś prowadzącego",
      "role": "Rola",
      "create": "Utwórz link",
      "link": "Link z zaproszeniem",
      "expires": "Jednorazowy, ważny do {{date}}",
      "copy": "Kopiuj",
      "copied": "Link skopiowany",
      "copyFailed": "Nie udało się skopiować — zaznacz link ręcznie"
    }
  },
  "invite": {
    "eyebrow": "Zaproszenie na seans",
    "name": "Jak się przedstawisz",
    "continue": "Dalej",
    "asHost": "Wejdziesz jako prowadzący — {{name}}",
    "ended": "Ten seans już się zakończył.",
    "bannedBadge": "Dostęp zablokowany",
    "invalid": "Link do seansu nie działa",
    "invalidHint": "Możliwe, że prowadzący zmienił link. Poproś o nowy.",
    "askToJoin": "Poproś o wejście"
  },
  "lobby": {
    "eyebrow": "Sprawdzenie przed wejściem",
    "preview": "Podgląd kamery",
    "join": "Wejdź do sali",
    "headphones": "W słuchawkach dźwięk filmu nie trafi do twojego mikrofonu.",
    "micLevel": "Głośność mikrofonu",
    "deviceNumbered": "Urządzenie {{number}}",
    "device": {
      "camera": "Kamera",
      "microphone": "Mikrofon",
      "speaker": "Głośniki"
    },
    "problem": {
      "denied": "Przeglądarka zablokowała dostęp: {{device}}",
      "notFound": "Nie znaleziono urządzenia: {{device}}. Podłącz je i kliknij „Spróbuj ponownie”.",
      "inUse": "{{device}} — urządzenie zajęte przez inny program (Zoom, Teams, inna karta). Zamknij go i kliknij „Spróbuj ponownie”.",
      "insecure": "Kamera i mikrofon działają tylko przez bezpieczny link (https).",
      "unsupported": "Ta przeglądarka nie obsługuje kamery i mikrofonu. Otwórz link w Chrome, Safari lub Firefoksie.",
      "unknown": "Nie udało się włączyć: {{device}}. Kliknij „Spróbuj ponownie”."
    },
    "guide": {
      "chrome": "Kliknij ikonę ustawień po lewej stronie adresu, włącz „Kamera” i „Mikrofon”, a potem kliknij „Spróbuj ponownie”.",
      "edge": "Kliknij kłódkę obok adresu, otwórz „Uprawnienia dla tej witryny”, zezwól na kamerę i mikrofon, a potem kliknij „Spróbuj ponownie”.",
      "yandex": "Kliknij kłódkę w pasku adresu, zezwól na kamerę i mikrofon, a potem kliknij „Spróbuj ponownie”.",
      "opera": "Kliknij kłódkę w pasku adresu, zezwól na kamerę i mikrofon, a potem kliknij „Spróbuj ponownie”.",
      "samsung": "Otwórz menu → „Ustawienia” → „Witryny i pobieranie” → „Uprawnienia witryn”, zezwól na kamerę i mikrofon, a potem kliknij „Spróbuj ponownie”.",
      "firefox": "Kliknij przekreśloną ikonę kamery w pasku adresu, usuń blokadę i kliknij „Spróbuj ponownie”.",
      "safari": "Otwórz Safari → „Ustawienia dla tej witryny”, wybierz „Zezwalaj” dla kamery i mikrofonu, a potem kliknij „Spróbuj ponownie”.",
      "safariIos": "Stuknij „aA” w pasku adresu → „Ustawienia witryny”, zezwól na kamerę i mikrofon, a potem stuknij „Spróbuj ponownie”.",
      "other": "Zezwól stronie na dostęp do kamery i mikrofonu w ustawieniach przeglądarki i kliknij „Spróbuj ponownie”."
    }
  },
  "call": {
    "mic": {
      "on": "Włącz mikrofon",
      "off": "Wyłącz mikrofon",
      "onWithHold": "Włącz mikrofon (lub przytrzymaj spację)",
      "isOff": "Mikrofon wyłączony"
    },
    "camera": {
      "on": "Włącz kamerę",
      "off": "Wyłącz kamerę",
      "isOn": "Kamera włączona"
    },
    "settings": "Urządzenia i dźwięk",
    "deviceProblem": "Urządzenie niedostępne",
    "pushToTalk": "Mów, przytrzymując spację",
    "pushToTalkHint": "Gdy mikrofon jest wyłączony",
    "you": "{{name}} (ty)",
    "participants": "Uczestnicy",
    "sync": {
      "idle": "Nie ogląda",
      "synced": "Ogląda równo z salą",
      "catching_up": "Nadrabia",
      "buffering": "Ładuje się"
    }
  },
  "player": {
    "label": "Film",
    "notReady": "Film jest jeszcze przygotowywany",
    "timeline": "Pozycja w filmie",
    "timeOf": "{{position}} z {{duration}}",
    "mute": "Wycisz",
    "unmute": "Włącz dźwięk",
    "volume": "Głośność",
    "settings": "Ustawienia oglądania",
    "subtitles": "Napisy",
    "subtitlesOff": "Wyłączone",
    "audio": "Ścieżka dźwiękowa",
    "quality": "Jakość",
    "qualityAuto": "Auto",
    "qualityAutoAt": "Auto · {{height}}p",
    "ducking": "Ściszaj film, gdy ktoś mówi",
    "duckingHint": "Tylko u ciebie",
    "joinPlayback": "Włącz film i dźwięk",
    "loadFailed": "Film się nie ładuje.",
    "fullscreen": "Pełny ekran",
    "exitFullscreen": "Zamknij pełny ekran",
    "play": "Odtwórz",
    "pause": "Pauza",
    "hostControls": "Filmem steruje prowadzący",
    "start": "Rozpocznij seans",
    "startsOn": "Początek {{date}}",
    "startsIn": "Początek za {{time}}",
    "waitingForHost": "Zaraz zaczynamy — czekamy na prowadzącego",
    "poster": "Plakat filmu"
  },
  "moderation": {
    "menu": "Działania: {{name}}",
    "muteMicrophone": "Wyłącz mikrofon",
    "muteCamera": "Wyłącz kamerę",
    "remove": "Usuń z sali",
    "ban": "Usuń i zablokuj",
    "muted": {
      "microphone": "Mikrofon: {{name}} — wyłączony",
      "camera": "Kamera: {{name}} — wyłączona"
    },
    "removed": "{{name}} nie ma już w sali",
    "removeTitle": "Usunąć {{name}} z sali?",
    "removeConsequence": "{{name}} opuści salę. Może wrócić przez link z zaproszeniem.",
    "removeConfirm": "Usuń",
    "banTitle": "Usunąć i zablokować {{name}}?",
    "banConsequence": "{{name}} opuści salę i nie wróci na ten seans, nawet przez link.",
    "banConfirm": "Usuń i zablokuj"
  },
  "chat": {
    "label": "Wiadomości",
    "older": "Pokaż wcześniejsze",
    "empty": "Nie ma jeszcze wiadomości — zacznij rozmowę",
    "you": "Ty",
    "sending": "wysyłanie…",
    "failed": "nie wysłano",
    "retry": "Wyślij ponownie",
    "discard": "Usuń",
    "message": "Wiadomość",
    "placeholder": "Wiadomość do sali",
    "send": "Wyślij"
  },
  "room": {
    "count_one": "{{count}} uczestnik",
    "count_few": "{{count}} uczestników",
    "count_many": "{{count}} uczestników",
    "count_other": "{{count}} uczestnika",
    "leave": "Wyjdź z sali",
    "panel": {
      "label": "Czat i uczestnicy",
      "chat": "Czat",
      "people": "Osoby · {{count}}",
      "hide": "Ukryj czat",
      "show": "Pokaż czat"
    },
    "connection": {
      "connecting": "Łączenie…",
      "reconnecting": "Ponowne łączenie…",
      "unavailable": "Brak połączenia"
    },
    "closed": {
      "toInvite": "Do zaproszenia",
      "ended": {
        "title": "Seans zakończony",
        "description": "Dziękujemy za wspólne oglądanie.",
        "action": "Do zaproszenia"
      },
      "removed": {
        "title": "Usunięto cię z sali",
        "description": "Możesz wrócić przez ten sam link.",
        "action": "Wróć do sali"
      },
      "banned": {
        "title": "Dostęp do seansu zablokowany",
        "description": "Prowadzący zablokował ci wejście na ten seans.",
        "action": "Do zaproszenia"
      },
      "left": {
        "title": "Jesteś poza salą",
        "description": "Film leci dalej — możesz wrócić w każdej chwili.",
        "action": "Wróć do sali"
      },
      "replaced": {
        "title": "Seans jest otwarty w innej karcie",
        "description": "Tutaj go zamknęliśmy, żeby dźwięk się nie dublował.",
        "action": "Oglądaj tutaj"
      },
      "denied": {
        "title": "Prośba o wejście została odrzucona",
        "description": "Jeśli to pomyłka, napisz do prowadzącego i sprawdź ponownie.",
        "action": "Sprawdź ponownie"
      }
    }
  },
  "admission": {
    "welcome": "Prowadzący cię wpuścił — wchodzisz do sali",
    "waitingEyebrow": "Czekasz na wejście",
    "waitingTitle": "Czekamy, aż prowadzący cię wpuści",
    "waitingHint": "Prowadzący widzi twoją prośbę. Gdy ją przyjmie, sala otworzy się sama — w tym czasie sprawdź kamerę i mikrofon.",
    "waitingSection": "Chcą wejść",
    "refusedSection": "Odrzuceni",
    "admit": "Wpuść: {{name}}",
    "admitShort": "Wpuść",
    "deny": "Odrzuć: {{name}}",
    "deniedBy": "Odrzucone przez: {{name}} · {{when}}",
    "requested": "{{name}} chce wejść",
    "dialogTitle": "Prośby o wejście",
    "nobody": "Nikt nie czeka na wejście",
    "waitingCount": "Chcą wejść: {{count}}"
  }
}
